import script from "./CDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CDialog.vue?vue&type=style&index=0&id=0033e9da&lang=scss"

const __exports__ = script;

export default __exports__